/**
 * Totals one field across cargos, or null when not one of them carries it — so a caller can leave a
 * figure out rather than claim a zero. Callers that always want a number append `?? 0`.
 *
 * Generic over the cargo shape: the EOS and Shipment API types name these fields differently
 * (`total_weight` vs `weight`, `qty` vs `pallet_space_quantity`), and this way each call site is
 * still checked against the type it actually passes.
 */
export const totalCargos = <T extends object>(cargos: T[], field: keyof T & string): number | null => {
	/* A weight can arrive from the API as a decimal string, so a cargo counts as carrying the field
	   whenever it holds something numeric — not only when it is already a number. */
	const carrying = (cargos ?? []).filter((cargo) => {
		const value = cargo[field];
		return value !== null && value !== undefined && value !== '' && !Number.isNaN(Number(value));
	});
	return carrying.length ? carrying.reduce((total, cargo) => total + Number(cargo[field]), 0) : null;
};
